import React from 'react';
import Navigation from '../components/Navigation';
import GmaxPokemon from '../components/GmaxPokemon';
import Logo from '../components/Logo';
import Footer from '../components/Footer';
const Gmax = () => {
    return (
        <div>
            <Logo/>
            <Navigation />
            <GmaxPokemon />
            <Footer />
        </div>
    );
};

export default Gmax;

